import { useEffect, useState } from "react"
import { TempStat } from "../../../utils/api-objects/TempStat"
import { getStatsByEmail } from "../../../utils/apis/user-service"
import { useAuth } from "../../../utils/context/AuthContext"

export const useGetStatsByEmail = (patientEmail: string | null) => {
    const { auth } = useAuth()
    const idToken = auth.idToken

    const [stats, setStats] = useState<TempStat[]>([])
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<Error | null>(null)

    useEffect(() => {
        if (!patientEmail || !idToken) {
            setIsLoading(false)
            return
        }

        const fetchStats = async () => {
            try {
                const data = await getStatsByEmail(patientEmail, idToken)
                setStats(data)
            } catch (err: any) {
                console.error("Failed to fetch stats:", err)
                setError(err)
            } finally {
                setIsLoading(false)
            }
        }

        fetchStats()

    }, [patientEmail, idToken])

    return { stats, isLoading, error }
}